//frontend/src/auth/Auth0ProviderWithNavigate.tsx
import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

export function Auth0ProviderWithNavigate({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();

  const domain = process.env.REACT_APP_AUTH0_DOMAIN!;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID!;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE!;

  // const redirectUri = window.location.origin;
  const redirectUri = process.env.REACT_APP_AUTH0_REDIRECT_URI || window.location.origin;

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience,
        scope: 'openid profile email',
        max_age: 3600, // force re-login after 1 hour
      }}
      cacheLocation="memory"
      useRefreshTokens={false}
      useRefreshTokensFallback={false}
      onRedirectCallback={(appState) => {
        const params = new URLSearchParams(window.location.search);
        const err = params.get('error');

        if (err === 'access_denied') {
          // Send to a clean route (and remove the ugly querystring loop)
          navigate('/access-denied' + window.location.search, { replace: true });
          return;
        }

        navigate(appState?.returnTo || '/', { replace: true });
      }}
    >
      {children}
    </Auth0Provider>
  );
}
